var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-radial-menu-wrapper", style: _vm.style },
    [
      _c(
        "div",
        {
          class: ["vue-radial-menu-container", _vm.shouldOpen && "open"],
          style: _vm.style,
          on: { click: _vm.handleClick }
        },
        [_c("BIcon", { attrs: { icon: _vm.icon } })],
        1
      ),
      _vm.shouldOpen ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }